module.exports = __webpack_public_path__ + "media/images/lp-worker-icon@2x-de2e98e714312d2a554d2138d9375111.png";